<app-loading *rxIf="viewModel.isLoading$" [options]="viewModel.loadingOpts$ | push"></app-loading>
<lib-sticky-modal [height]="'90vh'">
  <lib-sticky-header [stickyCollectionKey]="stickyCollectionKey" [stickyOrder]="0" [stickyZ]="stickyZ">
    <div class="modal-header no-bottom-border">
      <div class="modal-title-container">
        <div class="modal-title">{{ viewModel.title$ | push }}</div>
      </div>
    </div>
  </lib-sticky-header>
  <lib-sticky-body [placeInSameZPlaneAsHeaderAndFooter]="true">
    <app-product-groups-picker-filters
      [productGroups]="viewModel.unassignedProductGroups$ | push"
      [stickyCollectionKey]="stickyCollectionKey"
      [stickyOrder]="1"
      [stickyZ]="stickyZ"
      (filteredProductGroups)="viewModel.connectToProductGroupsToDisplay($event)"
      (numberOfProductsPerPage)="viewModel.connectToNItemsPerPage($event)">
    </app-product-groups-picker-filters>
    <app-product-groups-picker-table
      [productGroups]="viewModel.productGroupsToDisplay$ | push"
      [stickyCollectionKey]="stickyCollectionKey"
      [stickyOrder]="2"
      [stickyZ]="stickyZ"
      [nItemsToDisplay]="viewModel.nItemsPerPage$ | push"
      [externalPaginator]="paginator"
      (idsToBeAdded)="viewModel.connectToProductGroupIdsToBeAdded($event)">
    </app-product-groups-picker-table>
  </lib-sticky-body>
  <lib-sticky-footer>
    <div class="add-product-groups-to-brand-footer-container">
      <lib-reactive-table-paginator
        #paginator
        [style.visibility]="!(paginator.dataToDisplay$ | push)?.length ? 'hidden' : null">
      </lib-reactive-table-paginator>
      <lib-button-layout>
        <lib-button-neutral (buttonClicked)="cancel()"> Cancel </lib-button-neutral>
        <lib-button-primary [disabled]="viewModel.submitDisabled$ | push" (buttonClicked)="viewModel.submit()">
          {{ viewModel.primaryButtonText$ | push }}
        </lib-button-primary>
      </lib-button-layout>
    </div>
  </lib-sticky-footer>
</lib-sticky-modal>
